import React, { useEffect, useState } from 'react';
import {
  NavItem,
  NavLink,
  UncontrolledTooltip,
} from 'reactstrap';

import {
  sendFigmaPostMessage,
} from '../../../helpers/Figma';
import { isMiniFigmaIntegration } from '../../../helpers/App';

const FigmaSave = () => {
  const [isWindowSmall, setIsWindowSmall] = useState(false);

  const getBodyDimensions = () => {
    const body = document.querySelector('body');

    return {
      width: body.offsetWidth,
      height: body.offsetHeight,
    };
  };

  useEffect(() => {
    const widthBoundary = 450;
    const heightBoundary = 120;

    const updateDimensions = () => {
      const body = document.querySelector('body');

      if (body.offsetWidth < widthBoundary && body.offsetHeight < heightBoundary) {
        setIsWindowSmall(true);
      } else {
        setIsWindowSmall(false);
      }
    };

    const resizeObserver = new ResizeObserver(updateDimensions);

    const body = document.querySelector('body');
    resizeObserver.observe(body);

    return () => {
      resizeObserver.unobserve(body);
    };
  }, []);

  if (!isMiniFigmaIntegration()) return null;

  return (
    <>
      <NavItem>
        <NavLink
          id="FigmaSwitchSizeButton"
          onClick={() => sendFigmaPostMessage('switch-size', getBodyDimensions())}
          tag="a"
          href="#"
        >
          <i className="fal fa-expand mr-0" />
        </NavLink>
      </NavItem>
      <UncontrolledTooltip fade={false} target="FigmaSwitchSizeButton" placement="left">
        {isWindowSmall ? 'Expand' : 'Minimize'}
      </UncontrolledTooltip>
    </>
  );
};

export default FigmaSave;
